/**
 * 이 파일은 Aui 의 일부입니다. (https://aui.moimz.tools)
 *
 * Store 요소 통합 인덱스를 정의한다.
 *
 * @file /src/namespaces/models/Store.ts
 * @author Arzz <arzz@arzz.com>
 * @license MIT License
 * @modified 2026. 6. 5.
 */
import { Local as ListLocal } from '@models/store/list/Local';
import { Remote as ListRemote } from '@models/store/list/Remote';
import { Local as TreeLocal } from '@models/store/tree/Local';
import { Remote as TreeRemote } from '@models/store/tree/Remote';
import type { Record as RecordBase } from '@models/store/Record';

export type Record = {
    Record: { new (): RecordBase };
};

export const Store = {
    List: { Local: ListLocal, Remote: ListRemote },
    Tree: { Local: TreeLocal, Remote: TreeRemote },
};
